const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate joinBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const _source$separator = source.separator,
    separator = _source$separator === void 0 ? ', ' : _source$separator,
    leftSource = source.leftSource,
    rightSource = source.rightSource;
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values && values.length) {
    return values.join(separator);
  }
  const leftValue = await evaluateSource(leftSource, content, parentContentPath, transientContext, nativeFunctions);
  const rightValue = await evaluateSource(rightSource, content, parentContentPath, transientContext, nativeFunctions);
  if (leftValue !== undefined && rightValue !== undefined) {
    return [leftValue, rightValue].join(separator);
  }
  return undefined;
};
module.exports = {
  evaluate
};